<h3 mat-dialog-title>{{ data?.title }}</h3>
<div class="content" mat-dialog-content>
  <p *ngIf="data?.message" [innerHTML]="data?.message"></p>
  <ng-container *ngIf="data.messages">
    <p *ngFor="let message of data.messages" [innerHTML]="message"></p>
  </ng-container>
</div>

<div mat-dialog-actions [ngClass]="data.reverseButtons ? 'button-footer-reverse' : 'button-footer'">
  <goab-button
    type="primary"
    [ngClass]="{ warning: data?.destructiveConfirm }"
    autofocus
    [mat-dialog-close]="true"
    [size]="data.buttonSize ? data.buttonSize : 'normal'"
    data-cy="confirm-yes"
  >
    {{ data?.confirmLabel || 'Yes' }}
  </goab-button>
  <goab-button
    type="secondary"
    [size]="data.buttonSize ? data.buttonSize : 'normal'"
    data-cy="confirm-no"
    [mat-dialog-close]="false"
  >
    {{ data?.cancelLabel || 'No ' }}
  </goab-button>
</div>
